import {
  ButtonWithLoading,
  ErrorModal,
  ResponseMESF,
} from "@dexteel/mesf-core";
import { Grid, IconButton } from "@mui/material";
import { AddCircleOutlineOutlined as AddCircleOutlineOutlinedIcon } from "@mui/icons-material";
import { GetApp as GetAppIcon } from "@mui/icons-material";
import { useState } from "react";
import { ConfirmationDialogRaw } from "../../controls/modals/ConfirmationDialogRaw";

type Props = {
  show?: { new?: boolean; plc?: boolean };
  setShowModal?: (show: "NEW") => void;
  hasMaxItems?: boolean;
  readFromPLC?: (value?: string) => Promise<ResponseMESF>;
  table?:
    | "probes"
    | "strands"
    | "charges"
    | "additions"
    | "phases"
    | "pourbacks"
    | "wireAdditions"
    | "heatings"
    | "injections"
    | "plugMetrics"
    | "";
  justifyContent?:
    | "center"
    | "flex-end"
    | "flex-start"
    | "space-between"
    | "space-around"
    | "space-evenly";
  pause?: () => void;
  resume?: () => void;
};

export const AgGridFooterActions = ({
  show = { new: true, plc: true },
  setShowModal = () => {},
  hasMaxItems = false,
  readFromPLC,
  table = "",
  justifyContent = "space-between",
  pause = () => {},
  resume = () => {},
}: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);

  return (
    <>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ minHeight: "48px" }}
      >
        <Grid
          item
          md={6}
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            minHeight: "48px",
          }}
        >
          {show.new && (
            <IconButton
              color="primary"
              onClick={() => {
                pause();
                setShowModal("NEW");
              }}
              disabled={hasMaxItems}
              title={`Add ${table}`}
            >
              <AddCircleOutlineOutlinedIcon style={{ cursor: "pointer" }} />
            </IconButton>
          )}
        </Grid>
        <Grid
          item
          md={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            minHeight: "48px",
          }}
        >
          {show.plc && (
            <ButtonWithLoading
              isLoading={isLoading}
              fullWidth
              variant="outlined"
              color="primary"
              onClick={() => {
                pause();
                setOpenConfirmModal(true);
              }}
              title="Get from PLC"
              size="small"
              style={{ width: "20%" }}
            >
              <GetAppIcon />
            </ButtonWithLoading>
          )}
        </Grid>
      </Grid>
      <ConfirmationDialogRaw
        title="Confirmation"
        message={`Are you sure you want to continue? This will set up values from PLC in automatic ${table}`}
        open={openConfirmModal}
        onClose={(value) => {
          setOpenConfirmModal(false);
          if (readFromPLC) readFromPLC(value);
          resume();
        }}
      />
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
